import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import { IPost, fetchPostsByCreatedTime } from "@/lib/community";

const PAGE_SIZE = 10;

export function usePostsAdmin(search: string, isDeleted: boolean) {
  const queryClient = useQueryClient();

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["admin-posts", search ?? "", isDeleted],
    queryFn: ({ pageParam = 0 }) =>
      fetchPostsByCreatedTime({ pageParam, pageSize: PAGE_SIZE, search, isDeleted }),
    getNextPageParam: (lastPage, allPages) =>
      lastPage && lastPage.length === PAGE_SIZE
        ? allPages.length * PAGE_SIZE
        : undefined,
    initialPageParam: 0,
  });

  const posts = data ? data.pages.flat() : [];

  const handleAddTopPost = (post: IPost) => {
    queryClient.setQueryData(["posts", search ?? ""], (old: any) => {
      if (!old) {
        return { pages: [[post]], pageParams: [0] };
      }
      return {
        ...old,
        pages: [[post, ...old.pages[0]], ...old.pages.slice(1)],
      };
    });
  };

  const handleUpdatePost = (updatedPost: IPost) => {
    queryClient.setQueryData(["posts", search ?? ""], (old: any) => {
      if (!old) return old;
      return {
        ...old,
        pages: old.pages.map((page: IPost[]) =>
          page.map((p) => (p.id === updatedPost.id ? updatedPost : p))
        ),
      };
    });
  };
  return {
		queryClient,
    posts,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    handleAddTopPost,
    refetch,
    handleUpdatePost
  };
}
